//import logo from "./logo.svg";
import "./App.css";
import "./Map.css";
// import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "rc-slider/assets/index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import ProductPage from "./Pages/ProductPage";
import ProductDetail from "./Pages/ProductDetail";
import TrainingCourses from "./Pages/TrainingCourses";
import CoursesDetailPage from "./Pages/CoursesDetailPage";
import JobsHirePage from "./Pages/JobsHirePage";
import JobsHireDetailsPage from "./Pages/JobsHireDetailsPage";
import DroneLonesPage from "./Pages/DroneLonesPage";
import SingleTrainingInstitute from "./components/trainingCourse/SingleTrainingInstitute";
import { ToastContainer, toast } from "react-toastify";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearError, clearSuccess } from "./redux/slice/errorSlice";
import AllBlogPage from "./Pages/AllBlogPage";
import SingleBlogDetailsPage from "./Pages/SingleBlogDetailsPage";
import EnlistNewDronePage from "./Pages/EnlistNewDronePage";
import EnlishNewDroneLanding from "./components/enlistNewDronePage/EnlishNewDroneLanding";
import DronePartsPage from "./Pages/DronePartsPage";
import IntellegenceMarketSolutionPage from "./Pages/IntellegenceMarketSolutionPage";
import DronePartDetailsPage from "./Pages/DronePartDetailsPage";
import DroneSoftwareDetailsPage from "./Pages/DroneSoftwareDetailsPage";
import Cart from "./components/Cart/Cart";
import Wcart from "./components/Cart/Wcart";
import DroneSpace from "./Pages/DroneSpace";
import Orders from "./components/orders/Orders";
import OrderDetail from "./components/orders/OrderDetail";
import EnterpriseDealerPage from "./Pages/EnterpriseDealerPage";
import PartsManufacturerPage from "./Pages/PartsManufacturerPage"
import ContactUsPage from "./Pages/ContactUsPage";
import DroneSevicesPage from "./Pages/DroneSevicesPage";
import TermsAndConditionsPage from "./Pages/TermsAndConditionsPage";
import axios from "axios";
import Cookies from "js-cookie";
import { hanleChangeCartCount } from "./redux/slice/userSlice";
import TendersPage from "./Pages/TendersPage";
import HelpPopUp from "./components/common/HelpPopUp";
import EntrepreneurPage from "./Pages/EntrepreneurPage";
import RTPOPage from "./Pages/RTPOPage";
import AllTendersPage from "./Pages/AllTendersPage";
import TenderDetailsPage from "./Pages/TenderDetailsPage";
import ReturnPolicyPage from "./Pages/ReturnPolicyPage";
import ShippingPolicyPage from "./Pages/ShippingPolicyPage";
//import Services from "./components/droneSevicesPage/Services";
import QuickRegistrationForm from "./components/jobsHireDetailsPage/QuickRegistrationForm";
import Feedback from "./components/homepage/FeedBack";
import WhyChooseUs from "./components/homepage/WhyChooseUs";
import Account from "./components/homepage/Account";
import Faqs from "./components/homepage/Faqs";
import AllFormsLink from "./components/homepage/AllFormsLink";
import PrivacyPolicyPage from "./Pages/PrivacyPolicyPage";
import LandingPage from "./components/homepage/LandingPage";
import PreorderComponent from "./components/orders/PreorderComponent";
import EnlishNewDroneHero from "./components/enlistNewDronePage/EnlishNewDroneHero";
import Viraj from "./components/productDetails/Viraj";
import UploadMou from "./components/homepage/UploadMou";
import ChatBot from "./components/orders/Chatbot";
import DroneshalaPages from "./components/droneshala/DroneshalaPages";
import Features from "./components/droneshala/Features";
import Heros from "./components/droneshala/Heros";
import ELibrary from "./components/droneshala/Elibrary";
import Droneshala from "./components/droneshala/Droneshala";
import CourseRecommendation from "./components/droneshala/CourseRecommendation";
import WhyDrone from "./Pages/WhyDrone";
import Daas from "./components/daas/Daas"
import DaasLandingpage from "./components/daas/DaasLandingpage"
import EnlistYourInstitute from "./components/trainingCourse/EnlistYourInstitute";
import InstituteLandingpage from "./components/CoursesDetailePage/InstituteLandingpage";
import Loader from "./components/loader/Loaderr";
import DaasServicePage from "./Pages/DaasServicePage";
import Taas from "./components/tenders/Taas";
import DroneSpaceMap from "./components/droneSpace/DroneSpaceMap";
import DroneshalaForm from "./components/droneshala/DroneshlaForm";
import DroneZoneMap from "./components/droneSevicesPage/DroneZoneMap";
import WorkshopLanding from "./components/CoursesDetailePage/WorkshopLanding"
import Financial from "./components/droneLonePage/Financial";
import VendorForms from "./components/homepage/VendorForms";
import DroneXplores from "./Pages/DroneXplores";
import EnlistRentalDrone from "./components/DroneRental/EnlistRentalDrone";
import ToastProvider from "./services/ToastProvider";
import DiwaliTheme from "./components/common/DiwaliTheme";
import CSCAuth from "./components/address/CSCAuth";
import AuthSuccess from "./Pages/AuthSuccess";
import SuvidhaKendra from "./Pages/SuvidhaKendraPage"
import CoOpSociety from "./Pages/CoOpSociety";
import NewHome from "./Pages/NewHomePage";
import "./i18n";
import VendorOnboarding from "./Pages/VendorOnboardingPage";
import DroneCityHaryana from "./Pages/DroneCityHaryana";
import HduyLandingPage from "./Pages/HduyLandingPage";
import PageSeo from "./components/common/PageSeo";
import DSKFormPage from "./Pages/DSKFormPage";
import Pilots from "./Pages/AllPilotsPage"

function App() {
  const dispatch = useDispatch();
  const success = useSelector((state) => state.error.success);
  const error = useSelector((state) => state.error.error);
  const [loading, setLoading] = useState(true);
  const toastShown = useRef(false);
  const location = useLocation();

    useEffect(() => {
    // simulate load or wait for data if needed
    setTimeout(() => {
      setLoading(false);
    }, 2000); // adjust delay as needed
  }, []);



  const handleGetAllItems = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/getAllItemsFromCart",
        {
          headers: {
            token: Cookies.get("token"),
          },
        }
      );
      if (response?.data?.status === "success") {
        const count = response?.data?.data?.length;
        dispatch(hanleChangeCartCount(count));
      }
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };
  useEffect(() => {
    handleGetAllItems();
  }, []);
  return (
    <>
    {/* <DiwaliTheme /> */}
    {loading && location.pathname !== "/dsk" && <Loader />}
      <PageSeo />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/product-detail/:id" element={<ProductDetail />} />
        <Route path="/training-courses/:id" element={<TrainingCourses />} />
        <Route path="/enlist-your-institute" element={<InstituteLandingpage />} />
        <Route
          path="/training-institute/:id"
          element={<SingleTrainingInstitute />}
        />
        <Route path="/courses-details/:id" element={<CoursesDetailPage />} />
        <Route path="/jobs-hire-page" element={<JobsHirePage />} />
        <Route
          path="/jobs-hire-detail-page/:id"
          element={<JobsHireDetailsPage />}
        />
        <Route path="/quick-registration-form/:jobId" element={<QuickRegistrationForm />} />
        <Route path="/drone-loan" element={<DroneLonesPage />} />
        <Route path="/taas/*" element={<Taas />} />


        <Route path="/drone-manufacturer" element={<EnterpriseDealerPage />} />
        <Route path="/drone-parts-manufacturer" element={<PartsManufacturerPage />} />
        <Route path="/all-blogs" element={<AllBlogPage />} />
        <Route path="/blog-details/:id" element={<SingleBlogDetailsPage />} />
        <Route path="/enlist-new-drone-page" element={<EnlistNewDronePage />} />
        <Route path="/enlist-new-drone" element={<EnlishNewDroneLanding />} />
        <Route path="/join-our-network" element={<VendorForms />} />
        <Route path="/drone-parts" element={<DronePartsPage />} />
        <Route path="/intellegence-market-solutions" element={<IntellegenceMarketSolutionPage />} />
        <Route
          path="/drone-part-details/:id"
          element={<DronePartDetailsPage />}
        />
        <Route
          path="/drone-software-details/:id"
          element={<DroneSoftwareDetailsPage />}
        />
        <Route path="/maps" element={<DroneZoneMap />} />
        <Route path="/finance" element={<Financial />} />
        <Route path="/wokshops" element={<WorkshopLanding />} />

        <Route path="/contact-page" element={<ContactUsPage />} />
        <Route path="/drone-services-page" element={<DroneSevicesPage />} />
        <Route path="/entrepreneur" element={<EntrepreneurPage />} />
        <Route path="/establishment-rpto" element={<RTPOPage />} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/viraj-spec" element={<Viraj />} />

        <Route
          path="/terms-and-conditions"
          element={<TermsAndConditionsPage />}
        />
        <Route path="/mou" element={<UploadMou/>}/>
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicyPage />}
        />
        <Route path="/chatbot" element={<ChatBot/>}/>
        <Route path="/cart" element={<Cart />} />
        <Route path="/wcart" element={<Wcart />} />
        <Route path="/drone-space" element={<DroneSpace />} />
        <Route path="/drone-spaces" element={<DroneSpaceMap />} />
        <Route path="/E-library" element={<ELibrary />} />
        <Route path="/daas-service-page" element={<DaasServicePage/>}/>
        <Route path="/csc" element={<CSCAuth/>}/>
        <Route path="/auth/success" element={<AuthSuccess />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/order-detail" element={<OrderDetail />} />
        <Route path="/preorder" element={ <PreorderComponent />} />
        <Route path="/tenders" element={<TendersPage />} />
        <Route path="/all-tenders" element={<AllTendersPage />} />
        <Route path="/tender-details/:id" element={<TenderDetailsPage />} />
        <Route path="/return-policy" element={<ReturnPolicyPage />} />
        <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
        <Route path="/Droneshala" element={<DroneshalaPages />} />
        <Route path="/Droneshalaa" element={<Droneshala />} />
        <Route path="/Dshala" element={<DroneshalaForm />} />
        <Route path="/quiz" element={<CourseRecommendation />} />
        <Route path="/account" element={<Account />} />
        <Route path="/Faqs" element={<Faqs />} />
        <Route path="/links" element={<AllFormsLink />} />
        <Route path="/whyChooseUs" element={<WhyChooseUs />} />
        <Route path="/DroneXplore" element={<DroneXplores/>}/>
        <Route path="/daas" element={<Daas />} />
        <Route path="/aboutdaas" element={<DaasLandingpage />} />
        <Route path="/Droneshala1" element={<Heros />} />
        <Route path="/Droneshala2" element={<Features />} />
        <Route path="/rental-drone" element={<EnlistRentalDrone />} />
        {/* <Route path="/dsk" element={<SuvidhaKendra />} /> */}
        <Route path="/vendor-onboarding" element={<VendorOnboarding />} />
        {/* <Route path="/services" element={<Services/>} /> */}
        <Route path="/co-op" element={<CoOpSociety/>} />
        <Route path="/newhome" element={<NewHome/>} />

         <Route path="/drone-city" element={<DroneCityHaryana />} />
         <Route path="/hduy" element={<HduyLandingPage />} />
         <Route path="/dsk-full-form" element={<DSKFormPage />}/>
         <Route path="/pilots" element={<Pilots />}/>

         <Route path="*" element={<p>Page Not Found</p>} />
      </Routes>
      <Feedback />
      <HelpPopUp />
    <ToastProvider />
    </>
  );
}

export default App;
